<template>
<div id="workerInfo">
   <div class="col-12 p-3 table-views d-flex align-items-center justify-content-around">
                <div class="col-2">
                    <div class="d-flex flex-column">
                        <span class="status col-12" style="background-color:#EDF9F0;font-size:11px;">
                                        <img class="centerImg1 mr-2"  src="@/assets/images/icons/check.svg" width="20px">Trabajador Activo
                         </span>  
                         <img class="centerImg1 mt-3 mx-auto"  :src="serverPath+'/'+dataUser.image" width="100%">
                    </div>
                </div>
                <div class="col-10 px-3 table-responsive">
                    <datatable
                    :columns="datatableEmployee1.columns"
                    :data="datatableEmployee1.rows"
                    class="col-12 mt-5"
                    >
                    </datatable>
                    <datatable
                    :columns="datatableEmployee2.columns"
                    :data="datatableEmployee2.rows"
                    class="col-12"
                    >
                    </datatable>
                </div>
    </div>
</div>
</template>

<script>
import serverConfig from "./../../services/config";
export default {
    props: {
        dataUser:{}
    },
    data() {
        return {
            serverPath: serverConfig.permisosURL,
            datatableEmployee1: {
              columns:[],
              rows:[]
            },
            datatableEmployee2: {
              columns:[],
              rows:[]
          },
        }
    },
    beforeMount(){
        this.loadRows()
    },
    methods: {
        loadRows(){
            this.datatableEmployee1.columns = [
                    {
                        label: "Nombre",
                        field: "name",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Área",
                        field: "area",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Cargo",
                        field: "charge",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Fecha de ingreso",
                        field: "startDate",
                        align: "left",
                        headerClass: "theading",
                    },
                    
           ]
           this.datatableEmployee1.rows.push({
               name:this.dataUser.employee,
               area:this.dataUser.area,
               charge:this.dataUser.charge,
               startDate:(this.dataUser.created_at?this.dataUser.created_at:'---'),
           })
           this.datatableEmployee2.columns = [
                    {
                        label: "Género",
                        field: "gender",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Edad",
                        field: "age",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Télefono",
                        field: "phone",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Sindicato",
                        field: "sindicate",
                        align: "left",
                        headerClass: "theading",
                    },
                    
           ]
           this.datatableEmployee2.rows.push({
               gender:(this.dataUser.gender?this.dataUser.gender:'---'),
               age:(this.dataUser.age?this.dataUser.age:'---'),
               phone:(this.dataUser.phone?this.dataUser.phone:'---'),
               sindicate:this.dataUser.labor_union
           })
        }
    },
}
</script>

<style lang="scss">
#workerInfo{
    .table-views{
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
        border-radius: 8px;
        border:#DDDDDD solid 1px;
        padding: 0;
        margin: 30px 5px;
        font-size: 14px;
        .theading{
            width: 25%;
        }
    }
    .tableAbs{
        font-size: 14px;
        tbody tr{
            cursor: pointer;
        }
        tbody tr:hover{
            background-color: #F5F5F5;
        }
    }
    .t-head{
        background-color: #F5F5F5;
        padding: 5px 15px;
        text-align: left;
    }
    input{
        padding: 10px 10px;
        font-size: 15px;
        height: 50px;
        border-radius: 10px;
    }
    .theading{
        padding: 10px 10px;
        background-color: #EEF2FA;
        text-align: left;
    }
    tbody tr td{
        padding: 10px 10px;
    }
}

</style>